import * as React from 'react';

import { CanvasAutoplayForMobileConfigurationContext, frameworkCanvasAutoplayForMobile } from './canvasAutoplayForMobileConfiguration';

const withCanvasAutoplayForMobileConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <CanvasAutoplayForMobileConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkCanvasAutoplayForMobile} />
                );
            }}
        </CanvasAutoplayForMobileConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withCanvasAutoplayForMobileConfiguration;